<template>
<span>
  <q-icon size="l" color="red" class="cp" name="help" >
   <q-tooltip>
          {{label}}
        </q-tooltip>

        
  </q-icon>
 <!-- <q-popup-edit v-model="label" auto-save v-slot="scope">
        <q-input type="textarea" v-model="scope.value" dense autofocus counter @keyup.enter="scope.set" @update:model-value="save"/>
      </q-popup-edit> -->
        <!-- <q-btn @click="save" label="speichern" color="red" class="w100"/> -->

      <q-popup-edit v-model="label" auto-save v-slot="scope" @update:model-value="save" v-if="canEdit">
        ID: {{props.id}}
        <q-input outlined type="textarea" v-model="scope.value" dense autofocus counter @keyup.enter="scope.set" />
      </q-popup-edit>
</span>
  </template>

<script setup>
import { ref,inject  } from 'vue';
const props=defineProps({
  id:String
})
const web = inject("web")
const storage = inject("storage")
const user=storage.getUser()
const promoter=storage.get("promoter")
let canEdit=false;
if(user!=null && user.role=="admin"){
  canEdit=true
}
if(promoter!=null && promoter.iHadUserRole=="admin"){
  canEdit=true
}



const fragezeichen = inject('fragezeichen');

let label=ref("n.a.")
if(typeof(fragezeichen)!="undefined"){
  label.value = fragezeichen[props.id]
}



async function save(){
  
  await web.post("/saveFragezeichen",{id:props.id,label:label.value})
}
</script>
